<template>
  <panel 
		title="Client"
		dark	>
    <v-layout>
      <v-flex xs6>
        <div class="client-name">
          Name: {{ client.name }}
        </div>
      </v-flex>
    </v-layout>
  </panel>
</template>

<script>
import {mapState} from 'vuex'
export default {
	props: [
		'client'
	],
	computed: {
		...mapState([
			'isUserLoggedIn',
			'user'
		])
	},
	watch: {
		async client () {
			if (!this.isUserLoggedIn) {
				return
			}
		}
	}
}

</script>
<style scoped>
.client-name {
  text-align: left;
  font-family: "Arial";
  font-size: 12px;
	text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/components/ViewClient/ClientMetadata.vue